// extracted by mini-css-extract-plugin
export default {"tooltip":"Gn-z","sharingV2":"Hn-z","sharingIconsV2":"In-z","links":"Jn-z","link":"Kn-z","facebookV2":"Ln-z","twitterV2":"Mn-z","pinterestV2":"Nn-z"};